import React from "react";
import { HiOutlineArrowsRightLeft } from "react-icons/hi2";
import { useDispatch, useSelector } from "react-redux";
import { setPageDialog } from "../../../../app/slices/jomla/safeSlice";
import JSafeTransferTable from "./home/table";
import JSafeTransferHeader from "./home/header";
import FormDialog from "../../../../components/FormDialog";

const JSafeTransfer = () => {
  const _JSafeTransfer = useSelector((state) => state.jSafe);

  const dispatch = useDispatch();

  const handleDialog = () => {
    dispatch(setPageDialog());
  };

  return (
    <FormDialog
      open={_JSafeTransfer.dialog}
      onClose={() => {
        handleDialog();
      }}
      icon={<HiOutlineArrowsRightLeft />}
      title="المناقلات"
      maxWidth="xl"
    >
      <JSafeTransferHeader />
      <JSafeTransferTable />
    </FormDialog>
  );
};

export default JSafeTransfer;
